export enum AssetType {
  Company = 'company',
}

export enum AssetHistoryType {
  Investment = 'INVESTMENT',
  Realisation = 'REALISATION',
  Revaluation = 'REVALUATION',
}
